

















import {Component, Mixins} from 'vue-property-decorator';

import LiveMeta from '@/mixins/LiveMeta';

import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';
import CustomCursor from '@/components/ui/CustomCursor.vue';
import Recaptcha from '@/components/recaptcha/Recaptcha.vue';
import isIE from '@/utils/ie';

@Component({
	components: {
		'v-header': Header,
		'v-footer': Footer,
		'v-cursor': CustomCursor,
		'v-recaptcha': Recaptcha
	}
})
export default class DefaultLayout extends Mixins(LiveMeta) {

	get activeCategory(): number {
		return this.$store.state.help.activeCategory;
	}

	async mounted(): Promise<void> {

		if (typeof window === 'undefined') {
			return;
		}

		await this.$store.dispatch('updateRecaptchaState', this.$refs.hiddenRecaptcha);

		await isIE();

	}

	hiddenRecaptchaRender(data: { widgetId: number, widget: Recaptcha }): void {
		window.vueRecaptcha = data.widget;
	}

}
